<template>
  <div id="pdfDom" v-if="Datalist.length">
    <h2>{{ title }}</h2>
    <p>打印时间：{{ date }}</p>
    <div class="box" v-for="(user,u) in Datalist" :key="u">
      <div class="user-item">
        <div class="title">社工信息</div>
        <div class="flex-box">
          <el-image v-if="user.community_worker_info && user.community_worker_info.user_avatar"
            class="avatar" crossorigin="anonymous" @load='load' @error='error'
            :src="user.community_worker_info.user_avatar+'?t='+new Date().getTime()"
            fit="cover"></el-image>
          <el-image v-else
            class="avatar" crossorigin="anonymous"
            :src="avatarDefault" @load='load' @error='error'
            fit="cover"></el-image>
          <div class="flex-1">
            <div class="flex-fs kv">
              <div class="name">社工姓名</div>
              <div class="value flex-1">{{ user.founders || user.nurse_user_name }}</div>
            </div>
            <div class="flex-fs kv">
              <div class="name">性别</div>
              <div class="value flex-1" v-if="user.community_worker_info">{{ user.community_worker_info.user_sex | isSex }}</div>
            </div>
            <div class="flex-fs kv">
              <div class="name">联系电话</div>
              <div class="value flex-1" v-if="user.community_worker_info">{{ user.community_worker_info.user_phone }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="user-item">
        <div class="title">服务对象信息</div>
        <div class="flex-box">
          <el-image v-if="user.customer_photo_path"
            class="avatar" crossorigin="anonymous" @load='load' @error='error'
            :src="user.customer_photo_path + '?t='+new Date().getTime()"
            fit="cover"></el-image>
            <el-image v-else
              class="avatar" crossorigin="anonymous"
              :src="avatarDefault" @load='load' @error='error'
              fit="cover"></el-image>
              <span class="death" v-if="user.is_death == 1">已去世</span>
          <div class="flex-1">
            <div class="flex-fs kv">
              <div class="name">服务对象姓名</div>
              <div class="value flex-1">{{ user.customer_name }}</div>

              <div class="name">性别</div>
              <div class="value" style="width: 100px;text-align: center;">{{ user.customer_sex | isSex }}</div>

              <div class="name">联系电话</div>
              <div class="value flex-1">{{ user.customer_phone }}</div>

            </div>
            <div class="flex-fs kv">
              <div class="name">身份证号</div>
              <div class="value flex-1">{{ user.customer_identity_card_number }}</div>

              <div class="name">年龄</div>
              <div class="value" style="width: 100px;text-align: center;">{{ user.customer_age }}</div>

              <div class="name">贫困编号</div>
              <div class="value flex-1">{{ user.customer_poverty_number || '-' }}</div>
            </div>
            <div class="flex-fs kv">
              <div class="name">居住地址</div>
              <div class="value flex-1">{{ user.customer_current_address }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="user-item">
        <div class="title">通话记录</div>
        <div class="img-box flex-box">
          <template v-if="(user.call_record_file && user.call_record_file.length)">
            <el-image v-for="(item,i) in user.call_record_file" :key="i" crossorigin="anonymous"
              class="img" @load='load' @error='error'
              :src="item + '?t='+new Date().getTime()"
              fit="contain"></el-image>
          </template>
          <div v-else class="nodate">
            暂无数据
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import avatarDefault from '@/assets/avatar-default.png'
  export default{
    props:{
      list:{
        type: Array,
        default(){
          return []
        }
      },
      title: {
        type: String,
        default: '服务对象基本信息'
      }
    },
    data(){
      return {
        date: '',
        avatarDefault: avatarDefault,
        hasLoadedLength: 0,
        imgLength: 0,
        toDownload: false,
        Datalist: []
      }
    },
    watch: {
      list(newlist){
        let len = newlist.length*2
        newlist.forEach(i=>{
          i.call_record_file = i.call_record_file || []
          len += i.call_record_file.length
        })
        this.Datalist = []
        setTimeout(()=>{
          this.Datalist = newlist
        },100)
        this.hasLoadedLength = 0
        this.imgLength = len
      }
    },
    created() {

    },
    methods:{
      load(){
        this.hasLoadedLength += 1
        this.handleDownload()
      },
      error(){
        this.imgLength -= 1
        this.handleDownload()
      },
      handleDownload(){
        if(this.toDownload && (this.imgLength <= this.hasLoadedLength)){
          console.log('图片总数：',this.imgLength,'，已加载：',this.hasLoadedLength)
          console.log('开始下载')
          this.toDownload = false
          setTimeout(()=>{
            this.getPdf(this.title)
          }, 1000)
          setTimeout(()=>{
            this.$emit('success')
          }, 4000)
        }
      },
      download(){
        let that = this;
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        month = month < 9 ? '0' + month : month
        let day = date.getDate()
        day = day < 9 ? '0' + day : day
        let hour = date.getHours()
        hour = hour < 9 ? '0' + hour : hour
        let minute = date.getMinutes()
        minute = minute < 9 ? '0' + minute : minute
        let second = date.getSeconds()
        second = second < 9 ? '0' + second : second
        this.date = year + '-' +  month + '-' + day + ' '+ hour + ':' + minute
        this.toDownload = true
        this.handleDownload()
      }
    }
  }
</script>

<style lang="scss" scoped>
  #pdfDom{
    padding: 30px;
    width: 1000px;
    .nodate{
      text-align: center;
      line-height: 100px;
      flex: 1;
      color: #999;
    }
    h2{
      text-align: center;
      padding-bottom: 30px;
    }
    p{
      margin-bottom: 20px;
      text-align: right;
    }
    position: fixed;right: -99999px;
    .box{
      margin-bottom: 80px;
      .user-item{
        border: 1px solid #CACCCB;
        margin-bottom: 30px;
        position: relative;
        .death {
          position: absolute;
          top: 44px;
          left: 0;
          background: #b52929;
          color: white;
          padding: 0 5px;
          display: inline-block;
          line-height: 20px;
          font-size: 12px;
        }
      }
      .title{
        line-height: 44px;
        font-size: 17px;
        font-weight: bold;
        padding: 0 15px;
        border-bottom: 1px solid #CACCCB;
      }
      .avatar{
        height: 130px;
        width: 100px;
        margin-top: 2px;
        margin-left: 2px;
        margin-right: 2px;
      }
      .kv{
        border-bottom: 1px solid #CACCCB;
        border-left: 1px solid #CACCCB;
        &:nth-last-of-type(1){
          border-bottom: none;
        }
        .name{
          width: 100px;
          line-height: 44px;
          text-align: center;
          font-size: 15px;
          font-weight: bold;
          background-color: #E1E3E2;
          border-right: 1px solid #CACCCB;
        }
        .value{
          padding: 0 15px;
        }
      }
      .img-box{
        flex-wrap: wrap;
        .img{
          margin: 20px;
          width: calc(25% - 40px);
          height: 300px;
        }
      }

    }

  }
</style>